<template>
  <div id="app">
    <router-view />
    <div :style="{opacity:dialogSwitch?1:0}">
      <dialog-component v-if="$store.state.dialogData.dialogObj.dialogShow"></dialog-component>
    </div>
  </div>
</template>

<script>
//全局dialog 弹窗 用vuex 控制 是否显示、显示内容
import dialogComponent from '@/components/common/dialogComponent'

export default {
  name: 'App',
  components: { dialogComponent },
  data() {
    return {
      dialogSwitch: false,
    }
  },
  beforeMount() {
    const isNewUser = !localStorage.getItem('TenantMobile') //是否是老用户
    const currentHash = window.location.hash.split('?')[0] //当前路由
    console.log('currentHash', currentHash)

    // 仅在登录首页（#/）时才做重定向，UI 改版后登录方式变为 el-tabs，
    // 实际 tab 切换由 login.vue 的 created 根据 lastLoginRoute 接管
    const isRecordRoute = ['#/'].some((item) => item === currentHash)
    const lastLoginRoute = localStorage.getItem('lastLoginRoute') // 是否有上一次登录方式

    // 根据上一次登录方式跳转
    if (lastLoginRoute) {
      // 如果有上一次登录方式 则跳转到上一次登录方式
      if (isRecordRoute) this.$router.replace(lastLoginRoute)
    } else {
      //如果没有则判断是否是新用户 跳转到对应登录方式
      if (isRecordRoute) this.$router.replace(isNewUser ? '/accountLogin' : '/')
    }

    //
    setTimeout((_) => {
      this.dialogSwitch = true
    }, 100)
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#aliNc {
  margin-bottom: 30px;
  margin-top: -20px;
  position: relative;
}
#aliNc.nc-container .nc_scale span {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue